<ng-container *ngIf="cs.vm$ | async as vm">
  <div [content]="banner" editable-area></div>

  <div [content]="contactUsPanels" editable-area></div>

  <div [content]="main" editable-area></div>
</ng-container>
